export default __webpack_public_path__ + "static/portfolio-img-5-1da70e498d5ef5d4c51fc40e028b8c2c.png";